import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Pin from "../../asset/PinMaps-Icon.svg";
import { DepotPin } from "../../asset";

const MAP_API = "https://maps.googleapis.com/maps/api/js?";
const API_KEY = "AIzaSyBoFXsJLCpUvgSmLqLEQSqaGphqKfxnlfk";

const MapsMultipleMarker = compose(
  withProps({
    googleMapURL: `${MAP_API}libraries=places&key=${API_KEY}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => {
  return (
    <>
      <GoogleMap
        defaultZoom={11}
        defaultCenter={{
          lat: props?.lat ? Number(props?.lat) : -6.294844,
          lng: props?.long ? Number(props?.long) : 106.840837,
        }}
      >
        <Marker
          onClick={() => props.onClicks()}
          position={{
            lat: props?.lat ? Number(props.lat) : -6.294844,
            lng: props?.long ? Number(props.long) : 106.840837,
          }}
          name={"RSUD Pasar Minggu"}
          icon={{
            url: DepotPin,
            anchor: new window.google.maps.Point(5, 58),
          }}
        ></Marker>
        {props?.listLatLng
          ? props?.listLatLng?.map((item, index) => {
              return (
                <Marker
                  key={index}
                  // onClick={() => props.onClicks()}
                  position={{
                    lat: Number(item?.latt),
                    lng: Number(item?.long),
                  }}
                  name={item?.order_name}
                  icon={{
                    url: Pin,
                    anchor: new window.google.maps.Point(5, 58),
                  }}
                ></Marker>
              );
            })
          : alert("tidak termapping")}
      </GoogleMap>
    </>
  );
});

export default MapsMultipleMarker;
